import React, { useEffect, useRef, useState } from "react";
import { _post } from "../Api";
import { toast } from "react-toastify";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import { Checkbox, FormControlLabel, TableCell, Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import TablePagination from "@material-ui/core/TablePagination";
import { parse } from "date-fns";
import Paper from "@material-ui/core/Paper";
import SearchForms from "../components/Forms/SearchForms";
import cloudStore from "./../store/CloudStore";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { Visibility } from "@material-ui/icons";
import { useDialog } from "../components/Dialogs/DialogProvider";
import DetailedOrder from "../components/AllOrders/DetailedOrder";
import "../components/AllOrders/AllOrders.css";
import { makeStyles } from "@material-ui/core/styles";
import GetCurrency from "../helper/GetCurrency";

function getOrders(merchantIds, page = 1, rowsPerPage = 15, cursor = "") {
  const data = { merchantIds: merchantIds };
  return _post("/nova/v2/ordergroups/index?page=" + page + "&per_page=" + rowsPerPage + "&cursor=" +cursor, data)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

let timeout = null;

const useStyles = makeStyles((theme) => ({ root: { fontWeight: 800 } }));

function AllOrders(props) {
  const classes = useStyles();
  const [merchants, setMerchants] = useState([]);

  const [autorefresh, setAutorefresh] = useState(true);
  const [ordersAndCount, setOrdersAndCount] = useState(null);
  const [pageAndRowsPerPage, setPageAndRowsPerPage] = useState({ page: 0, rowsPerPage: 25 });
  const cursor = useRef("")

  const [openDialog] = useDialog();

  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }
    if (autorefresh) {
      timeout = setTimeout(() => {
        // setOrdersAndCount(null);
        setMerchants([...merchants]);
      }, 15000);
    }

    console.log(ordersAndCount)

    getOrders(
      merchants.map((merchant) => merchant.merchant_id),
      pageAndRowsPerPage.page + 1,
      pageAndRowsPerPage.rowsPerPage,
      cursor.current
    ).then((data) => {
      setOrdersAndCount(data);
    });
  }, [merchants, pageAndRowsPerPage]);

  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            color={"primary"}
            checked={autorefresh}
            onChange={(e) => {
              setAutorefresh(e.target.checked);
            }}
          />
        }
        label={"Auto refresh 15 seconds"}
      />

      <Paper>
        {merchants.map((merchant, index) => {
          return (
            <Button
              variant={"outlined"}
              color={"error"}
              onClick={() => {
                merchants.splice(index, 1);
                setMerchants([...merchants]);
              }}
            >
              Remove {merchant.name}
            </Button>
          );
        })}
        <SearchForms
          allResults={cloudStore.filteredMerchants.filter((merchant) => merchant.merchant_id > 0)}
          handleSelect={(merchant) => {
            setMerchants([...merchants, merchant]);
          }}
        />
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow classes={{ root: classes.root }}>
              <TableCell>ID</TableCell>
              <TableCell>Merchant</TableCell>
              <TableCell>POS</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Payment Status</TableCell>
              <TableCell>POS Status</TableCell>
              <TableCell>POS Attempts</TableCell>
              <TableCell>Type / Table</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Created at</TableCell>
              <TableCell>By</TableCell>
              <TableCell>View</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ordersAndCount?.rows.map((order) => {
              if (!order.ordergroupable) {
                return null;
              }

              let statusColor = null;
              let status = order.ordergroupable.sp_receipt
                ? order.status
                : order.ordergroupable.pillar_device_id
                ? order.ordergroupable.receipt_status_id
                : order.ordergroupable.status;

              switch (status) {
                case "PENDING":
                  statusColor = "blue";
                  break;
                case "PAID":
                  statusColor = "orange";
                  break;
                case 1:
                case "ORDERED":
                  statusColor = "blue";
                  break;
                case 2:
                case "FINISHED":
                  statusColor = "green";
                  break;
                case "FAILED":
                case 3:
                case "CANCELED":
                  statusColor = "yellow";
                  break;
              }

              let paymentStatusColor = null;
              switch (order.payment_status) {
                case "PENDING":
                  paymentStatusColor = "blue";
                  break;
                case "PAID":
                  paymentStatusColor = "green";
                  break;
                case "FAILED":
                  paymentStatusColor = "red";
                  break;
                case "CANCELED":
                  paymentStatusColor = "yellow";
                  break;
              }

              let posStatusColor = null;
              switch (order.pos_status) {
                case "PENDING":
                  posStatusColor = "blue";
                  break;
                case "ORDERED":
                  posStatusColor = "green";
                  break;
                case "FAILED":
                  posStatusColor = "red";
                  break;
              }
              return (
                <TableRow key={order.id + "-" + order.updated_at} className={"blink"}>
                  <TableCell>{order.id}</TableCell>
                  <TableCell>{order.merchant.name}</TableCell>
                  <TableCell>{order.merchant.merchantable_type ?? "Standalone"}</TableCell>
                  <TableCell style={{ color: statusColor }}>{status}</TableCell>
                  <TableCell style={{ color: paymentStatusColor }}>{order.payment_status}</TableCell>
                  <TableCell style={{ color: posStatusColor }}>{order.pos_status}</TableCell>
                  <TableCell>{order.pos_attempts}</TableCell>
                  <TableCell>
                    {order.ordergroupable.sp_receipt
                      ? "Inhouse / " + order.ordergroupable.sp_receipt.table_id
                      : order.ordergroupable.receipt_type
                      ? order.ordergroupable.receipt_type + " / " + order.ordergroupable.table_id
                      : order.ordergroupable.pillar_device_id
                      ? "Kiosk"
                      : ""}
                  </TableCell>
                  <TableCell>
                    {GetCurrency(order.merchant.currency)}
                    {order.ordergroupable.total_amount == null
                      ? ((order.total_amount + (order.tip_amount ?? 0) + (order.transaction_costs ?? 0)) / 100.0).toFixed(
                          2
                        )
                      : (
                          (order.ordergroupable.total_amount +
                            (order.tip_amount ?? 0)) /
                          100.0
                        ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    {order.ordergroupable.payment_method != null
                      ? order.ordergroupable.payment_method
                      : order.o_m_articles?.[0]?.transaction_o_m_articles?.[0]?.transaction?.transactionable
                          ?.payment_method}
                  </TableCell>
                  <TableCell>
                    <Typography noWrap={true}>
                      {parse(order.created_at + "Z", "yyyy-MM-dd HH:mm:ssX", new Date()).toLocaleString()}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {order.ordergroupable.sp_user_id > 0
                      ? "QR-App User"
                      : order.ordergroupable.sp_handheld_user_id > 0
                      ? "Handheld User"
                      : "POS"}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        openDialog({ children: <DetailedOrder order={order} />, fullWidth: true, maxWidth: "xl" });
                      }}
                    >
                      <Visibility />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {ordersAndCount == null ? (
        <div align="center">
          <CircularProgress color="primary" />
        </div>
      ) : null}
      <TablePagination
        count={ordersAndCount?.count}
        onChangePage={(e, page) => {
          if(page >pageAndRowsPerPage.page) {
            cursor.current = ordersAndCount?.next_cursor ?? "";
          } else {
            cursor.current = ordersAndCount?.prev_cursor ?? "";
          }
          setPageAndRowsPerPage({ ...pageAndRowsPerPage, page });
        }}
        page={pageAndRowsPerPage.page}
        rowsPerPage={pageAndRowsPerPage.rowsPerPage}
        onChangeRowsPerPage={(e) => {
          cursor.current = "";
          setPageAndRowsPerPage({ rowsPerPage: parseInt(e.target.value), page: 0 });
        }}
      />
    </div>
  );
}

export default AllOrders;
